import React from 'react';
import { useTranslation } from 'react-i18next';
import { AudioDevice } from '../../hooks/settings/audio-device.types';
import controlStyles from './MicrophoneSettingsControls.module.css';

interface SpeakerOutputSectionProps {
  audioOutputs: AudioDevice[];
  selectedOutput: string;
  onOutputChange: (deviceId: string) => void;
  onTestSpeaker: () => void;
}

export function SpeakerOutputSection({
  audioOutputs,
  selectedOutput,
  onOutputChange,
  onTestSpeaker,
}: SpeakerOutputSectionProps) {
  const { t } = useTranslation();

  return (
    <div className={controlStyles.section}>
      <label className={controlStyles.label}>
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
          <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
        </svg>
        {t('settings:mic.speaker')}
      </label>
      <select
        className={controlStyles.select}
        value={selectedOutput}
        onChange={(e) => onOutputChange(e.target.value)}
      >
        {audioOutputs.map((device) => (
          <option key={device.deviceId} value={device.deviceId}>
            {device.label}
          </option>
        ))}
      </select>

      <button className={controlStyles.testButton} onClick={onTestSpeaker}>
        {t('settings:mic.testSpeaker')}
      </button>
    </div>
  );
}
